// extracted by mini-css-extract-plugin
export default {"link":"NotificationBell_link__dHX0F","badge":"NotificationBell_badge__N5Ejv"};